import { Component, Input, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material";
import { Estudo } from "../estudo/estudo";
import { GrupoFamiliar } from "../grupo-familiar/grupo-familiar";
import { QuestionarioDinamicoService, QuestionarioRespostaVO } from "unb-questionario-componente";


@Component({
  templateUrl: "./comparacao-grupo.component.html",
  selector: "comparacao-grupo",
  styleUrls: ["comparacao-grupo.component.css"]
})
export class ComparacaoGrupoComponent implements OnInit{
  @Input() estudoAtual: Estudo;
  @Input() estudoComparacao: Estudo;
  @Input() botaoSelecionarPergunta: boolean= false;
  @Input() botaoSalvar: boolean=false;

  public idGrupoFamiliarSelecionado: number;
  public isLoading: boolean;

  public questionarioResposta1: QuestionarioRespostaVO;
  public questionarioResposta2: QuestionarioRespostaVO;

  public membroSelecionado1: GrupoFamiliar;
  public membroSelecionado2: GrupoFamiliar;

  constructor(private mensagem: MatSnackBar, private questionarioService: QuestionarioDinamicoService) {

  }

  ngOnInit(){


  }


  editarRecebidoAtual(membroSelecionado:GrupoFamiliar){
    this.membroSelecionado1 = membroSelecionado;

  }

  editarRecebidoComparacao(membroSelecionado:GrupoFamiliar){
    this.membroSelecionado2 = membroSelecionado;
  }

  carregaComparacao(idResposta1: number, idResposta2:number){
    this.isLoading = true;
    this.questionarioService.comparar(idResposta1, idResposta2)
    .subscribe((result: QuestionarioRespostaVO[]) => {
      this.questionarioResposta1= result[0];
      this.questionarioResposta2= result[1];
      this.isLoading = false;
    },
    error => this.erro(error));
  }

  private erro(erro: string): void{
    this.mensagem.open(erro, 'X', {duration: 5000});
    this.isLoading= false;
  }


}
